import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonPipeModule } from 'src/app/modules/common/common-pipe.module';
import { ContainerCardComponent } from './container-card.component';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { SanitizeModule } from 'src/app/modules/sanitize.module';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { TranslationModule } from 'src/app/modules/translation.module';

@NgModule({
	declarations: [
		ContainerCardComponent,
	],
	imports: [
		CommonModule,
		CommonPipeModule,
		TranslationModule.forChild(),
		FontAwesomeModule,
		SanitizeModule
	],
	exports: [
		ContainerCardComponent
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA
	]
})
export class ContainerCardModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(faArrowRight);
	}
}
